import { Component, ChangeDetectionStrategy } from '@angular/core';
import { combineLatest } from 'rxjs';
import { filter, map, mapTo, shareReplay, startWith, switchMapTo, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Organization, UserSummary } from '../client-api.service';
import { AppService } from '../shared/app.service';
import { SignatureInfo } from '../shared/signature-info';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent {

  signatureInfo: SignatureInfo | undefined;

  readonly state$ = combineLatest([this.appSvc.orgs$, this.appSvc.socialMediaServices$, this.appSvc.user$]).pipe(
    mapTo('ready'),
    startWith('loading'),
    shareReplay(1)
  );

  readonly initialSignature$ = this.state$.pipe(
    filter(x => x === 'ready'),
    switchMapTo(combineLatest([this.appSvc.orgMap$, this.appSvc.user$])),
    take(1),
    map(([orgMap, user]) => this.createSignatureInfo(orgMap, user))
  );

  constructor(private appSvc: AppService) { }

  private createSignatureInfo(orgMap: Map<string | undefined, Organization>, user: UserSummary | undefined): SignatureInfo {
    const org = orgMap.get(user?.orgCode) || orgMap.get(environment.defaultOrgCode);
    return {
      orgCode: org?.orgCode || '',
      personName: user?.name ?? '',
      phone: org?.primaryPhone || '',
      title: user?.title || ''
    };
  }
}
